function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8125 9.375L4 4.78125C4.125 3.78125 4.96875 3 6 3H17C18.0312 3 18.875 3.78125 19 4.78125L12.1875 9.375C11.7812 9.65625 11.2188 9.65625 10.8125 9.375ZM13.0312 10.625L19 6.59375V12C19 13.0938 18.0938 14 17 14H6C4.90625 14 4 13.0938 4 12V6.59375L9.96875 10.625C10.9062 11.25 12.125 11.25 13.0312 10.625ZM2.5 6.75V15C2.5 15.2812 2.71875 15.5 3 15.5H15.25C15.6562 15.5 16 15.8438 16 16.25C16 16.6562 15.6562 17 15.25 17H3C1.90625 17 1 16.0938 1 15V6.75C1 6.34375 1.34375 6 1.75 6C2.15625 6 2.5 6.34375 2.5 6.75Z",
  fill: "white"
});

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.8f74e3fc.svg";
export { ForwardRef as ReactComponent };